<template>
  <div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <wrapper-mobile-view>
        <div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
          <div class="w-100">
            <div class="row">
              <div class="col-1 align-self-center" @click="pageTo('account')">
                <div class="d-inline-grid cursor-pointer">
                  <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
                </div>
              </div>
              <div class="col-9 align-self-center">
                <p class="mb-0 body-1-2">Account Integration</p>
              </div>
            </div>
          </div>
        </div>
      </wrapper-mobile-view>
      <block :height="45" />
    	<div class="w-100 mt-5 px-4">
        <div class="w-100" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <div class="mb-3 w-100 p-4 radius-12 bg-white box-shadow-light-aff border-semi-grey" v-for="company in data">
            <div class="row mb-4 no-gutters">
              <div class="col-2 align-self-center">
                <img :src="company.logo" width="100%">
              </div>
              <div class="col-9 align-self-center">
                <div class="pl-3">
                  <p class="mb-0 body-1-4">{{ company.name }}</p>
                  <p class="mb-0 body-3-3-1">{{ company.website }}</p>
                </div>
              </div>
              <div class="col-1 align-self-center" v-if="company.status == 'CONNECTED'">
                <svg v-b-tooltip.hover title="Account connected" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_454_13)">
                    <path
                      d="M12.9936 25.9872C20.1019 25.9872 25.9872 20.0892 25.9872 12.9936C25.9872 5.88534 20.0892 0 12.9809 0C5.88534 0 0 5.88534 0 12.9936C0 20.0892 5.89808 25.9872 12.9936 25.9872Z"
                      fill="#28A745" />
                    <path
                      d="M11.5668 19.2229C11.1338 19.2229 10.7771 19.0445 10.4459 18.5987L7.2484 14.6751C7.05732 14.4203 6.94267 14.1401 6.94267 13.8471C6.94267 13.2738 7.38854 12.8025 7.96178 12.8025C8.3312 12.8025 8.61146 12.9172 8.92993 13.3375L11.516 16.6751L16.9554 7.93629C17.1974 7.55413 17.5286 7.35031 17.8599 7.35031C18.4204 7.35031 18.9427 7.73247 18.9427 8.3312C18.9427 8.61146 18.777 8.90445 18.6242 9.17196L12.6369 18.5987C12.3694 19.0191 12 19.2229 11.5668 19.2229Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_454_13">
                      <rect width="25.9872" height="26" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-12"  v-if="company.status == 'NOT_CONNECT'">
                <p class="body-2-2 mb-0">{{ company.description }}</p>
              </div>
              <template v-else>
                <div class="col-6">
                  <div class="w-100 pr-3">
                    <div class="w-100 mb-3">
                      <p class="mb-0 body-3">First name</p>
                      <p class="mb-0 body-2-4">{{ company.data.GivenName }}</p>
                    </div>
                    <div class="w-100 mb-3">
                      <p class="mb-0 body-3">Last name</p>
                      <p class="mb-0 body-2-4">{{ company.data.FamilyName }}</p>
                    </div>
                    <div class="w-100 mb-3">
                      <p class="mb-0 body-3">Email</p>
                      <p class="mb-0 body-2-4 text-truncate">{{ company.data.EmailAddress }}</p>
                    </div>
                    <div class="w-100">
                      <p class="mb-0 body-3">Phone number</p>
                      <p class="mb-0 body-2-4">{{ company.data.PhoneNumber }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="w-100 radius-6 bg-light-page p-3 border-form">
                    <div class="w-100 text-center mb-3 pb-3 border-b-form">
                      <p class="mb-0 text-20 font-lato text-green">{{ company.data.AvailableBalance }}</p>
                      <p class="mb-0 body-3">Available Balance</p>
                    </div>
                    <div class="w-100 mb-3">
                      <p class="mb-0 body-3">Program</p>
                      <p class="mb-0 body-2-4 text-truncate">{{ company.data.Program }}</p>
                    </div>
                    <div class="w-100">
                      <p class="mb-0 body-3">Membership number</p>
                      <p class="mb-0 body-2-4">{{ company.data.MembershipNumber }}</p>
                    </div>
                  </div>
                </div>
              </template>
              <div class="col-12 my-4">
                <div class="w-100 border-2-bottom-dashed"></div>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-12 mb-3" v-if="company.error_connect != ''">
                <ErrorMessage :message="company.error_connect" />
              </div>
              <div class="col-12">
                <state-button v-if="company.status == 'NOT_CONNECT'" variant="secondary" size="lg" block :click="connectToGetPlus">Connect your account</state-button>
                <button v-else class="g-btn g-btn-lg g-btn-dark-outline w-100" @click="toggleModalDisconnect">Disconnect this account</button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <b-modal ref="warning_disconnect" no-close-on-esc no-close-on-backdrop hide-header>
      <div class="py-5 px-4 text-center">
        <div class="mb-4">
          <svg width="110" height="100" viewBox="0 0 110 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_456_18)">
              <path
                d="M65.7815 93.6616C89.6789 93.6616 109.465 73.8328 109.465 49.9786C109.465 26.0814 89.6358 6.29551 65.7388 6.29551C41.8842 6.29551 22.0985 26.0814 22.0985 49.9786C22.0985 73.8328 41.9273 93.6616 65.7815 93.6616ZM65.7815 86.381C45.5676 86.381 29.4218 70.1926 29.4218 49.9786C29.4218 29.7644 45.5245 13.576 65.7388 13.576C85.9527 13.576 102.184 29.7644 102.184 49.9786C102.184 70.1926 85.9955 86.381 65.7815 86.381ZM95.0748 78.2011L94.9465 77.73C92.8477 71.4347 81.5417 64.5397 65.7815 64.5397C50.0641 64.5397 38.7581 71.4347 36.6166 77.6873L36.4882 78.2011C44.1972 85.8244 57.4302 90.2782 65.7815 90.2782C74.1756 90.2782 87.2804 85.8672 95.0748 78.2011ZM65.7815 57.2592C74.047 57.3447 80.4709 50.321 80.4709 41.1135C80.4709 32.4625 74.0042 25.3105 65.7815 25.3105C57.5588 25.3105 51.0494 32.4625 51.0922 41.1135C51.1349 50.321 57.5588 57.1733 65.7815 57.2592Z"
                fill="#EEB815" />
              <path
                d="M27.6231 100C42.6553 100 55.2463 87.4518 55.2463 72.3769C55.2463 57.2161 42.7836 44.7537 27.6231 44.7537C12.5054 44.7537 0 57.2161 0 72.3769C0 87.5801 12.4625 100 27.6231 100Z"
                fill="white" />
              <path
                d="M27.6231 94.1327C39.4002 94.1327 49.3789 84.2826 49.3789 72.3769C49.3789 60.4284 39.5716 50.6211 27.6231 50.6211C15.7173 50.6211 5.86724 60.4712 5.86724 72.3769C5.86724 84.3681 15.7173 94.1327 27.6231 94.1327Z"
                fill="#EEB815" />
              <path
                d="M27.6231 86.2528C25.6531 86.2528 23.9828 84.6682 23.9828 82.6552C23.9828 80.6851 25.6531 79.015 27.6231 79.015C29.636 79.015 31.2634 80.6851 31.2205 82.6552C31.2205 84.6682 29.5931 86.2528 27.6231 86.2528ZM27.6231 76.0599C26.1242 76.0599 25.0535 75.0319 25.0107 73.5759L24.6681 61.3274C24.6252 59.5718 25.8244 58.3727 27.6231 58.3727C29.4218 58.3727 30.621 59.5718 30.5781 61.3274L30.2355 73.5759C30.1927 75.0319 29.122 76.0599 27.6231 76.0599Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_456_18">
                <rect width="109.465" height="100" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <p class="mb-0 body-2-2 text-30 text-warning font-bold">Warning</p>
        <p class="mb-0 body-1-2 w-75 mx-auto">Are you sure you want to disconnect from the GetPlus account?</p>
      </div>
      <template slot="modal-footer">
        <div class="w-100">
          <div class="row slim-grid-row">
            <div class="col-6">
              <button class="g-btn g-btn-lg g-btn-dark w-100" @click="toggleModalDisconnect">Cancel</button>
            </div>
            <div class="col-6">
              <state-button variant="primary" block size="lg" :click="disconnectFromGetPlus">Continue Disconnect</state-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import getplusLogo from '../../../assets/img/brand/GetPlus.png'
  import { mapGetters } from 'vuex'
  import { post } from '@/services/index.js'
  
  export default{
    data() {
      return {
        is_load: false,
        error: '',
        data: [],
        error_connect: ''
      }
    },
    computed:{
      ...mapGetters(['getMerchant','isLoggedIn'])
    },
    mounted(){
      if(this.isLoggedIn && this.$isNotEmpty(this.getMerchant.use_getplus) && this.getMerchant.use_getplus == 1){
        this.loadFirstData()
      }else{
        this.$router.push(`/${this.getMerchant.code}`)
      }
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        let func_exc = [this.generateMenu(),this.getDataFromGetPlus()]
        Promise.all(func_exc)
          .catch(err=>this.error = err)
          .finally(()=>{
          this.is_load = false
        })
      },
      generateMenu(){
        return new Promise(done=>{
          this.data = []
          this.data.push({
            logo: getplusLogo,
            name: 'GetPlus',
            website: 'mygetplus.id',
            error_connect: '',
            status: 'NOT_CONNECT',
            data: {},
            description: 'GetPlus adalah aplikasi multi-brand reward program yang memberikan banyak poin dan rewards dari transaksi belanja harianmu. Tukar poin dengan voucher F&B, produk elektronik, produk investasi, dan ratusan reward menarik lainnya!'
          })
          done()
        })
      },
      connectToGetPlus(){
        return new Promise((success,fail)=>{
          post("BASE","getplus/link-account",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.$openLink(res.data)
            }else{
              this.data[0].error_connect = res.message
              setTimeout(() => {
                this.data[0].error_connect
              }, 3000);
            }
            success()
          })
        })
      },
      getDataFromGetPlus(){
        return new Promise((success,fail)=>{
          post("BASE","getplus/account",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.data[0].status = 'CONNECTED'
              this.data[0].data = res.data
            }
            success()
          })
        })
      },
      pageTo(page){
        this.$router.push(`/${this.getMerchant.code}/${page}`)
      },
      toggleModalDisconnect(){
        this.$refs.warning_disconnect.toggle()
      },
      disconnectFromGetPlus(){
        return new Promise((success,fail)=>{
          post("BASE","getplus/unlink-account",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.data[0].status = 'NOT_CONNECT'
              this.data[0].data = {}
            }else{
              this.data[0].error_connect = res.message
              setTimeout(() => {
                this.data[0].error_connect
              }, 3000);
            }
            this.toggleModalDisconnect()
            success()
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/account/Integration.vue